export const oxxioNavlinkOncolorColors = {
  navLinkSecondaryOnColorDefault: '{{ neutralColors.neutralWhite }}',
  navLinkSecondaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkSecondaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorDefault: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorHover: '{{ neutralColors.neutralWhite }}',
  navLinkTertiaryOnColorFocusOutline: '{{ neutralColors.neutralWhite }}',
};

export const navLinkStyledTextUnderline = {
  styledTextUnderline: `100% 0`,
};
